var render = function render(){var _vm=this,_c=_vm._self._c;return _c('erp-s-field',{attrs:{"view":"tl","label":"Reboquista"}},[_c('erp-select',{attrs:{"placeholder":"Qualquer","options":_vm.reboquistas,"multiple":_vm.multiple},on:{"input":_vm.__set},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }